<quill-editor
	[formControl]="form"
	[sanitize]="true"
	format="html"
	theme="snow"
	(onFocus)="handleOnFocus()"
	(onBlur)="handleOnBlur()"
	[modules]="modules"
	placeholder=""
	[attr.data-testid]="'text-editor'"
	[class.higher]="enableAdvancedFormatting"
/>
